import React, { Component } from "react";
import { geolocated } from "react-geolocated";
import './callbackjoin.css'

class Callbackjoin extends Component {
  constructor() {
    super();
    this.state = {
      gigs: [],
      id: ""
    };
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.coords !== this.props.coords) {
      await fetch("https://symphony-api.herokuapp.com/api/join", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          url: window.location.href,
          latitude: this.props.coords.latitude,
          longitude: this.props.coords.longitude
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            alert("There are no gigs near you, please create a gig");
            this.props.history.push("/");
          }
        })
        .then(json => {
          this.globalData(json);
          this.props.history.push("/joingig");
        });
    }
  }

  globalData(data) {
    window.id = data.id;
    window.gigs = data.gigs;
  }
  render() {
    return (
      <div>
        <div class="c-background" />
        <div class="lds-ring">
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true
  },
  userDecisionTimeout: 5000
})(Callbackjoin);



// WEBPACK FOOTER //
// ./src/callbackjoin.js